import { FC } from 'react';
import { ProgressBar } from 'shared/ui/progress-bar/progress-bar';
import { useTranslation } from 'hooks';
import cls from './subscription-card.module.scss';
import { useSubscriptions } from 'hooks/api/useSubscriptions';
import { Skeleton } from 'shared/ui/skeleton/skeleton';

export const SubscriptionCard: FC = () => {
  const { t } = useTranslation();
  const { count, isLoading } = useSubscriptions();
  const totalLicenses = count?.total ?? 0;
  const assignedLicenses = count?.assigned ?? 0;
  const hasPurchased = totalLicenses > 0;
  const progress = hasPurchased ? (assignedLicenses / totalLicenses) * 100 : 0;

  return (
    <div className={cls.subscriptionCard}>
      <div className={cls.cardHeader}>
        <h3>{t('licenses')}</h3>
      </div>

      <div className={cls.licenseCounter}>
        {isLoading ? (
          <div>
            <Skeleton height={52} />
          </div>
        ) : (
          <div className={cls.counterRow}>
            {hasPurchased ? (
              <>
                <span className={cls.counterNumber}>{assignedLicenses}</span>
                <div>
                  <span>{t('assigned')}</span>{' '}
                  <span className={cls.counterLabel}>
                    • {totalLicenses} {t('total')}
                  </span>
                </div>
              </>
            ) : (
              <>
                <span className={cls.counterNumber}>0</span>
                <span className={cls.counterLabel}>
                  {t('noPurchasedSubscriptions')}
                </span>
              </>
            )}
          </div>
        )}
        <div className={cls.progressBarWrapper}>
          {isLoading ? (
            <Skeleton height={4} />
          ) : (
            <ProgressBar
              score={progress}
              variant='detailed'
              progressClass={cls.progressFilled}
            />
          )}
        </div>
      </div>
    </div>
  );
};
